export default __webpack_public_path__ + "5a2dc279ac56c2cea08554666506939d.jpg";